import React from "react";
import DynamicBlock from "./DynamicBlock";

interface BlockWrapperProps {
  block: any;
  index: number;
  total: number;
  blockPath: number[];
  project: string;
  contentType: string;
  locale: string;
  onUpdate: (block: any) => void;
  onDelete: () => void;
  isDropTarget?: boolean;
  hoverGroupPath?: string | null;
  dragHandleRef?: (node: HTMLElement | null) => void;
  dragHandleListeners?: Record<string, any>;
  blockConfig?: any[];
}

const BlockWrapper: React.FC<BlockWrapperProps> = ({
  block,
  index,
  total,
  blockPath,
  project,
  contentType,
  locale,
  onUpdate,
  onDelete,
  isDropTarget,
  hoverGroupPath,
  dragHandleRef,
  dragHandleListeners,
  blockConfig
}) => {
  const handleDelete = () => {
    if (window.confirm(`Delete this ${block.type} block?`)) {
      onDelete();
    }
  };

  const renderBlock = () => {
    if (blockConfig) {
      const def = blockConfig.find((b: any) => b.type === block.type);
      if (def) {
        return (
          <DynamicBlock
            block={block}
            fields={def.fields || []}
            locale={locale}
            project={project}
            contentType={contentType}
            onUpdate={onUpdate}
            parentPath={blockPath}
            hoverGroupPath={hoverGroupPath}
            blockConfig={blockConfig}
          />
        );
      }
    }

    return (
      <div className="block__unknown">
        <code>{JSON.stringify(block, null, 2)}</code>
      </div>
    );
  };

  const isContainer = block.type === "group" || Array.isArray(block.content);

  return (
    <div className={`block-wrapper${isContainer ? " block-wrapper--group" : ""}${isDropTarget ? " block-wrapper--drop-target" : ""}`}>
      <div
        className="block-wrapper__side"
        ref={dragHandleRef}
        {...(dragHandleListeners || {})}
        title={dragHandleRef ? "Drag to reorder" : undefined}
      >
        <span className="block-wrapper__type">{block.type}</span>
      </div>
      <div className="block-wrapper__body">
        <div className="block-wrapper__content">{renderBlock()}</div>
        <div className="block-wrapper__actions">
          <button className="block-wrapper__btn block-wrapper__btn--danger" onClick={handleDelete} title="Delete block">
            <svg width="10" height="10" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
              <line x1="18" y1="6" x2="6" y2="18" /><line x1="6" y1="6" x2="18" y2="18" />
            </svg>
          </button>
        </div>
      </div>
    </div>
  );
};

export default BlockWrapper;
